import {
  LongWandHandBlueIllustration,
  LongWandHandGreenIllustration,
  LongWandHandRedIllustration,
  LongWandHandRedWithHatIllustration,
  LongWandHandYellowIllustration,
} from '@carboncopyco/illustrations';
import type { TextLargeParagraphProps } from '@carboncopyco/ui';
import { TextLargeParagraph } from '@carboncopyco/ui';
import type React from 'react';
import { useContext } from 'react';
import { DescriptionLink, type DescriptionLinkProps } from '../DescriptionLink';
import { RulesManagerContext } from './RulesManagerContext';

export interface RulesManagerEmptyStateProps {
  color?: IllustractionColor;
  children?: React.ReactNode;
}

export type IllustractionColor =
  | 'red'
  | 'yellow'
  | 'green'
  | 'blue'
  | 'redWithHat';

const colorToIllustration: Record<IllustractionColor, React.ReactNode> = {
  red: <LongWandHandRedIllustration />,
  yellow: <LongWandHandYellowIllustration />,
  green: <LongWandHandGreenIllustration />,
  blue: <LongWandHandBlueIllustration />,
  redWithHat: <LongWandHandRedWithHatIllustration />,
};

export const RulesManagerEmptyState = ({
  color = 'red',
  children,
}: RulesManagerEmptyStateProps) => {
  const Illustration = colorToIllustration[color] ?? null;
  return (
    <div className="h-full flex flex-col items-center justify-center gap-2.5 relative">
      <div className="absolute top-0 right-0 -mr-8 -mt-4 pointer-events-none">
        {Illustration}
      </div>
      {children}
    </div>
  );
};

type RulesManagerEmptyStateTitleProps = Pick<TextLargeParagraphProps, 'label'>;

const RulesManagerEmptyStateTitle = ({
  label,
}: RulesManagerEmptyStateTitleProps) => (
  <TextLargeParagraph
    label={label}
    color="text-ds-natural-600"
  />
);

RulesManagerEmptyState.Title = RulesManagerEmptyStateTitle;

type RulesManagerEmptyStateSubtitleProps = DescriptionLinkProps;

const RulesManagerEmptyStateSubtitle = ({
  label,
  linkLabel,
  linkUrl,
}: RulesManagerEmptyStateSubtitleProps) => {
  const { onLearnMoreClick } = useContext(RulesManagerContext);

  return (
    <DescriptionLink
      label={label}
      linkLabel={linkLabel}
      linkUrl={linkUrl}
      onLearnMoreClick={onLearnMoreClick}
    />
  );
};

RulesManagerEmptyState.Subtitle = RulesManagerEmptyStateSubtitle;
